import { GongIcon } from "#components/ui/GongIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const gongManifest: IntegrationManifest = {
    key: "gong",
    displayName: "Gong",
    nameKey: "channels.gong",
    descriptionKey: "gongDescription",
    trayDescriptionKey: "composerTrayDescriptions.gong",
    cardDescriptionKey: "connectIntegration.descriptions.gong",
    connectedContentKeys: ["gongCalls"],
    brandColor: "#8039E9",
    iconUrl: IconAssets.Gong,
    iconUrlAlt: IconAssets.GongAlt,
    glyph: GongIcon,
    channelType: "UserGongMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
